module.exports = __webpack_public_path__ + "img/down.74718f67.svg";